import React from 'react';

const Analytics = () => {
  return <>Analytics PAge</>;
};

export default Analytics;
